export const signIn = (credentials) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    
    firebase.auth().signInWithEmailAndPassword(
      credentials.email,
      credentials.password
    ).then(() => {
      dispatch({ type: 'LOGIN_SUCCESS' });
    }).catch((err) => {
      dispatch({ type: 'LOGIN_ERROR', err });
    });

  }
}

export const signInGuest = (distanceList, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    firebase.auth().signInAnonymously()
    .then((resp) => {
      console.log('signed in as guest');
      callback(resp.user.uid);
      return firebase.firestore().collection('users').doc(resp.user.uid).set({
        firstName: "Guest",
        lastName: "User",
        initials: "GU",
        address: "1101 W Main st",
        city: "Richmond",
        state: "VA",
        zip: "23220",
        location: [37.545607,-77.45552],
        email: false,
        createdAt: timestamp,
        distanceList: distanceList
    });
    })
    .catch((error) => {
      console.log(error);
      var errorCode = error.code;
      var errorMessage = error.message;
    // ...
    });
  }
}

export const signInGuest2 = (currentCity, currentAddress, currentZip, currentState, location, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    
    firebase.auth().signInAnonymously()
    .then((resp) => {
      console.log('signed in as guest');
      callback(resp.user.uid);
      return firebase.firestore().collection('users').doc(resp.user.uid).set({
        firstName: "Guest",
        lastName: "User",
        initials: "GU",
        address: currentAddress,
        city: currentCity,
        state: currentState,
        zip: currentZip,
        location: location,
        email: false,
        createdAt: timestamp
    });
    })
    .catch((error) => {
      console.log(error);
      var errorCode = error.code;
      var errorMessage = error.message;
    // ...
    });
  }
}

export const trackBot = (botInfo) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    firebase.firestore().collection('botTracker').add({
      ...botInfo,
      timestamp: timestamp
    });
  }
};


export const signOut = () => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();

    firebase.auth().signOut().then(() => {
      dispatch({ type: 'SIGNOUT_SUCCESS' })
    });
  }
}

export const signUp = (newUser, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();

    firebase.auth().createUserWithEmailAndPassword(
      newUser.email, 
      newUser.password
    ).then(resp => {
      callback(resp.user.uid);
      return firebase.firestore().collection('users').doc(resp.user.uid).set({
        firstName: newUser.firstName,
        lastName: newUser.lastName,
        initials: newUser.firstName[0] + newUser.lastName[0],
        address: newUser.address,
        city: newUser.city,
        state: newUser.state,
        location: newUser.location,
        email: newUser.email
      });
    }).then(() => {
      dispatch({ type: 'SIGNUP_SUCCESS' });
    }).catch((err) => {
      dispatch({ type: 'SIGNUP_ERROR'}, console.log(err));
    });
  }
}

export const signUpFavorites = (userId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const timestamp = new Date();
    const messageRef = firebase.firestore().collection('users/' + userId + '/favorites').doc();
      messageRef.set({
        timestamp:timestamp
      }).then(() => {
      dispatch({ type: 'SIGNUP_FAVORITES_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'SIGNUP_FAVORITES_ERROR' }, console.log(err));
      });
  }
};
